const Songs = [
	{
		id: 1,
		favourite: true,
		songName: "Bella Ciao",
		artist: "El Profesor",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FAila_Aila-StarMusiQ.Com.mp3?alt=media&token=583e94f6-a9eb-46dd-b6f0-029dcaae1e84",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/the-expendables.jpg",
	},
	{
		id: 2,
		favourite: false,
		songName: "Beast",
		artist: "Anirudh Ravichander",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FAndha_Arabi_Kadaloram-StarMusiQ.Com.mp3?alt=media&token=762a8b16-994e-46e3-b987-a7da3bd7e464",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/The-Sea-Beast.jpg",
	},
	{
		id: 3,
		favourite: false,
		songName: "Joker - Rock and Roll",
		artist: "Hildur Guðnadóttir",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FEnnai_Kaanavillaiye-VmusiQ.Com.mp3?alt=media&token=c7bfc250-8850-4429-8a3c-6f0e05cb8a16",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/The-Princess-scaled.jpg",
	},
	{
		id: 4,
		favourite: false,
		songName: "Bella Ciao",
		artist: "El Profesor",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FAila_Aila-StarMusiQ.Com.mp3?alt=media&token=583e94f6-a9eb-46dd-b6f0-029dcaae1e84",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/the-expendables.jpg",
	},
	{
		id: 5,
		favourite: false,
		songName: "Beast",
		artist: "Anirudh Ravichander",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FAndha_Arabi_Kadaloram-StarMusiQ.Com.mp3?alt=media&token=762a8b16-994e-46e3-b987-a7da3bd7e464",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/The-Sea-Beast.jpg",
	},
	{
		id: 6,
		favourite: false,
		songName: "Joker - Rock and Roll",
		artist: "Hildur Guðnadóttir",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FEnnai_Kaanavillaiye-VmusiQ.Com.mp3?alt=media&token=c7bfc250-8850-4429-8a3c-6f0e05cb8a16",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/The-Princess-scaled.jpg",
	},
	{
		id: 7,
		favourite: false,
		songName: "Bella Ciao",
		artist: "El Profesor",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FAila_Aila-StarMusiQ.Com.mp3?alt=media&token=583e94f6-a9eb-46dd-b6f0-029dcaae1e84",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/the-expendables.jpg",
	},
	{
		id: 8,
		favourite: false,
		songName: "Beast",
		artist: "Anirudh Ravichander",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FAndha_Arabi_Kadaloram-StarMusiQ.Com.mp3?alt=media&token=762a8b16-994e-46e3-b987-a7da3bd7e464",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/The-Sea-Beast.jpg",
	},
	{
		id: 9,
		favourite: false,
		songName: "Joker - Rock and Roll",
		artist: "Hildur Guðnadóttir",
		song: "https://firebasestorage.googleapis.com/v0/b/spotifyclone-ec0d9.appspot.com/o/Bombay%2FEnnai_Kaanavillaiye-VmusiQ.Com.mp3?alt=media&token=c7bfc250-8850-4429-8a3c-6f0e05cb8a16",
		imgSrc: "http://sksmovies.com/wp-content/uploads/2022/07/The-Princess-scaled.jpg",
	},
];

export { Songs };
